function nextScreen(router, route) {
    setTimeout( () => {
        router.push({path: route});
    }, 
    250);
}

function nextScreenWithParams(router, componentName, param) {
    setTimeout( () => {
        router.push({name: componentName, params: {generic: param}});
    }, 
    250);
}

function nextScreenWithMoreParams(router, componentName, first, second) {
    setTimeout( () => {
        router.push({name: componentName, params: {fi: first, sec: second}});
    }, 
    250);
}

export {nextScreen, nextScreenWithParams, nextScreenWithMoreParams}


// WEBPACK FOOTER //
// ./src/router/utils.js